import { render, staticRenderFns } from "./TextClamp.vue?vue&type=template&id=694ff898&scoped=true"
import script from "./TextClamp.vue?vue&type=script&lang=js"
export * from "./TextClamp.vue?vue&type=script&lang=js"
import style0 from "./TextClamp.vue?vue&type=style&index=0&id=694ff898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694ff898",
  null
  
)

export default component.exports